export default __webpack_public_path__ + "8e773d2c8235834bb5c1c4cc1fa3766b.svg";